/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HoldWorkOrderRequestDto
 */
export interface HoldWorkOrderRequestDto {
    /**
     * 
     * @type {string}
     * @memberof HoldWorkOrderRequestDto
     */
    reason: string;
}

/**
 * Check if a given object implements the HoldWorkOrderRequestDto interface.
 */
export function instanceOfHoldWorkOrderRequestDto(value: object): value is HoldWorkOrderRequestDto {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function HoldWorkOrderRequestDtoFromJSON(json: any): HoldWorkOrderRequestDto {
    return HoldWorkOrderRequestDtoFromJSONTyped(json, false);
}

export function HoldWorkOrderRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldWorkOrderRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
    };
}

export function HoldWorkOrderRequestDtoToJSON(json: any): HoldWorkOrderRequestDto {
    return HoldWorkOrderRequestDtoToJSONTyped(json, false);
}

export function HoldWorkOrderRequestDtoToJSONTyped(value?: HoldWorkOrderRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

